import React, { FC, useState } from 'react';
import { Chip as ChipType } from '..';
import { TableRoofMoreChip } from './moreChip';
import { PopoverMenuList } from '../../../../../../../dataDisplay/menuList/popoverMenuList';

type Props = {
  remainingChips: Array<ChipType>;
};

export const TableRoofMoreMenu: FC<Props> = ({ remainingChips }) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>();
  const listItems = remainingChips.map((chip) => ({
    ...chip,
    checked: true
  }));
  const closeAndCallDeleteFunctions = () => {
    setAnchorElement(null);
    listItems.forEach((item) => !item.checked && item.onDelete?.());
  };

  return (
    <>
      <TableRoofMoreChip
        count={remainingChips.length}
        onMoreClick={(event: React.MouseEvent<HTMLElement>) =>
          setAnchorElement(event.currentTarget)
        }
      />
      <PopoverMenuList
        config={listItems}
        anchor={anchorElement}
        closeMenu={closeAndCallDeleteFunctions}
      />
    </>
  );
};
